<script setup>
import { defineProps } from "vue";

const props = defineProps({
  name: String,
  middleDots: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">{{ props.name }}</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
            <li v-if="middleDots" class="breadcrumb-item">...</li>
            <li class="breadcrumb-item active">{{ props.name }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
